import Api from "../../../lib/api";

export const SECTOR_DATA = {
  start: "fetch_start/sdg_sunburst_data",
  end: "fetch_end/sdg_sunburst_data",
  success: "fetch_success/sdg_sunburst_data",
  failed: "fetch_failed/sdg_sunburst_data",
  clear: "clear/sdg_sunburst_data",
};

export const fetchSectorDataStart = () => ({
  type: SECTOR_DATA.start,
});

export const fetchSectorDataEnd = () => ({
  type: SECTOR_DATA.end,
});

export const fetchSectorDataReset = () => ({
  type: SECTOR_DATA.clear,
});

export const fetchSectorDataSuccess = (data) => ({
  type: SECTOR_DATA.success,
  data,
});

export const fetchSectorDataError = (error) => ({
  type: SECTOR_DATA.failed,
  error,
});

export const fetchSectorData = (vocabulary, year) => {
  return (dispatch) => {
    dispatch(fetchSectorDataStart());
    if (year !== "") {
      return Api.get(Api.API_SECTOR_DATA(vocabulary, year))
        .then((response) => {
          if (response.success && response.data) {
            const result = response.data.sectors.map((item) => ({
              ...item,
              image: `/static/assets/icons/sdg/SDG-${item.code}.svg`,
            }));
            dispatch(fetchSectorDataEnd());
            dispatch(fetchSectorDataSuccess(result));
          } else {
            dispatch(fetchSectorDataEnd());
          }
        })
        .catch((exception) => {
          dispatch(fetchSectorDataEnd());
          dispatch(fetchSectorDataError(exception));
        });
    } else {
      dispatch(fetchSectorDataReset());
      dispatch(fetchSectorDataEnd());
    }
  };
};



// WEBPACK FOOTER //
// ./components/sdgLandingPage/actions/index.js